(function() {

    var $emailPopup;
    var $emailAgreePopup;
    var emailValidation;
    var emailCertifiedCnt = 0;

    var $docPopup;
    var $docAgreePopup;
    var $docSuccessPopup;
    var docValidation;

    var loginFlag = digitalData.hasOwnProperty("userInfo") && digitalData.userInfo.unifyId ? "Y" : "N";
    var paramValue = "";

    var emailCertified = {
        init: function() {
            var self = this;

            var planEventId = $('#planEventId').val();
            var memberStatus = self.memberCheck();
            var checkEmail = $("#checkEmail").val() != null ? $("#checkEmail").val().split(',') : [];

            self.paramChk();

            if (lgkorUI.stringToBool(loginFlag)) {
                $('.login-ok').show();
                $('.login-no').hide();
            } else {
                $('.login-no').show();
                $('.login-ok').hide();
            }

            $emailPopup = $('#academyPopup02');
            $emailAgreePopup = $('#academyPopup04');
            $docPopup = $('#academyPopup03');
            $docAgreePopup = $('#academyPopup05');
            $docSuccessPopup = $('#academyPopup06');

            self.$submitForm = $('#emailCertifiedForm');
            self.$emailInput = $('#userEmail');
            self.$completeBtn = $('#btnCertified');
            self.$loginBtn = $('#btnLogin');
            self.$emailInput.attr('maxlength', 50);

            vcui.require(['ui/validation'], function() {
                var register = {
                    //이메일
                    userEmail: {
                        required: true,
                        pattern: /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+)*(\.ac\.kr|\.edu)$/,
                        minLength: 1,
                        maxLength: 50,
                        msgTarget: '.err-block',
                        errorMsg: '이메일 주소를 입력해주세요.',
                        patternMsg: '**@**.ac.kr 또는 **@**.edu 계정의 이메일을 입력해 주세요.',
                        validate: function(value) {
                            var email = value.split('@'),emailId = email[0], emailDomain = email[1];
                            if (emailId.length <= 30 && emailDomain != null && emailDomain.length <= 255) { 
                                var _pattern = new RegExp(this.pattern);
                                if (_pattern.test(value) == true) {
                                    return value.indexOf(".ac.kr") > -1 || value.indexOf(".edu") > -1 ? true : false;
                                } else {
                                    // 예외사항 처리
                                    return checkEmail.indexOf(emailDomain) > -1 && !!emailId.match(/^([0-9a-zA-Z_\.-]+)$/) ? true : false;
                                }
                            } else {
                                return false;
                            }
                        }
                    },
                    //약관동의
                    emailAgreeChk: {
                        required: true,
                        msgTarget: '#emailCertifiedForm .input-mix-wrap + .err-block',
                        errorMsg: '개인정보 수집 이용에 동의해 주세요.'
                    }
                }
                emailValidation = new vcui.ui.CsValidation('#emailCertifiedForm', {
                    register: register
                });
                self.bindEvent();
            });

            // BTOCSITE-33505 LG전자 아카데미 스토어 대문 변경 요청 > 유의사항 토글
            self.toggleOpenClick();

        },
        bindEvent: function() {
            var self = this;
            //이메일 인증 버튼 클릭시
            self.$completeBtn.on('click', function(e) {
                e.preventDefault();
                var planEventId = $('#planEventId').val();
                var memberStatus = self.memberCheck();

                if (memberStatus == 'Y') {
                    lgkorUI.alert("", {
                        title: '이미 인증 받은 회원입니다.<br>확인 버튼을 통해<br>아카데미 스토어를 이용해 주시기 바랍니다.',
                        okBtnName: '확인',
                        ok: function() {
                            location.href = "/benefits/exhibitions/detail-" + planEventId + paramValue;
                        }
                    });
                } else if (emailCertifiedCnt > 0) {     // BTOCSITE-34570 : 인증 신청 하였다면 다시 누르면 얼럿 노출
                    lgkorUI.alert("", {
                        title: '이메일 인증이 진행 중입니다.<br>입력하신 이메일을 확인해 주세요. ',
                        okBtnName: '확인',
                        ok: function() {}
                    });
                } else {
                    var result = emailValidation.validate();
                    if (result.success) {
                        var url = self.$submitForm.data('ajax');
                        var param = emailValidation.getAllValues();

                        var chk = $('#emailAgreeChk').prop('checked');
                        if(chk){
                            param['agreeUserCheck'] = 1;
                        } else {
                            lgkorUI.alert("", {
                                title: "개인정보 수집 이용에 동의해 주세요."
                            }, $('#emailAgreeChk'));
                            return;
                        }

                        param['agreeUserCheck'] = param['emailAgreeChk'] ? 1 : 0;

                        var formData = new FormData();

                        for (var key in param) {
                            formData.append(key, param[key]);
                        }
                        lgkorUI.showLoading();

                        lgkorUI.requestAjaxFileData(url, formData, function(result) {
                            var data = result.data;
                            if (data.resultFlag == 'Y') {
                                lgkorUI.hideLoading();
                                self.$submitForm.submit();
                                $('.email-certified-info').show();
                                $('.doc-verification-info').hide();
                                $emailPopup.find('.pop-footer').show();
                                $emailPopup.find('.pop-conts').animate({
                                    scrollTop: 200
                                }, 500);
                                emailCertifiedCnt++;    // 인증신청시 카운트 업
                            } else {
                                lgkorUI.hideLoading();
                                // 이미 등록된 이메일경우 
                                if (data.dupAuthEmail == '1') {
                                    lgkorUI.alert("", {
                                        title: '이미 인증을 받은 이메일 계정입니다.<br>다시 확인해 주시기 바랍니다.',
                                        okBtnName: '확인',
                                        ok: function() {}
                                    });
                                } else {
                                    lgkorUI.hideLoading();
                                    var $focus = data.target != null ? $('#'+data.target) : self.$completeBtn;
                                    if (data.resultMessage) {
                                        lgkorUI.alert("", {
                                            title: data.resultMessage, ok: function(){
                                                academyUtil.scroll($focus);
                                        }}, $focus);
                                    }
                                }
                            }
                        }, 'POST');
                    } else {
                        if(result.validArray.length > 0) {
                            var $focus = $('[name='+result.validArray[0].key+']');
                            if ($focus.length === 0) $focus = self.$completeBtn;
                            lgkorUI.alert('', {title: result.validArray[0].errmsg, ok: function(){
                                academyUtil.scroll($focus);
                            }}, $focus);
                        }
                    }
                }

            });
            $('#btnLogin').on('click', function(e) {
                location.href = '/sso/member/login';
            });
            $('#academyPopup01 .btn-list').on('click', function(e) {
                $('#academyPopup01').vcModal('hide');
                location.href = '/benefits/exhibitions';
            });

            // 이메일인증 - 신청완료 확인
            $emailPopup.find('.btn-confirm').on('click', function(e) {
                $emailPopup.vcModal('hide');
                location.reload();
            });

            // 이메일인증 - 닫기
            $emailPopup.find('.btn-close').on('click', function(e) {
                setTimeout(function(){
                    // 이메일인증 초기화
                    $('#userEmail').val('');
                    $('input[name=emailAgreeChk]').prop('checked', false);
                    $('input[name=emailAgreeRadio]').prop('checked', false);
                    $emailAgreePopup.find('.btn-confirm').addClass('disabled');
                    $('.err-block').hide();
                    $emailPopup.find('.tabs li:eq(0) a').trigger('click');
                }, 300);
            });

            // 이메일인증 약관팝업 - 동의/비동의
            $("input:radio[name=emailAgreeRadio]").on('click', function(e) {
                var $confirmBtn = $emailAgreePopup.find('.btn-confirm');
                if ($(this).val() == "N") {
                	$confirmBtn.addClass('disabled');
                } else {
                	$confirmBtn.removeClass('disabled');
                }
            });

            // 이메일인증 약관팝업 - 확인
            $emailAgreePopup.find('.btn-confirm').on('click', function(e) {
                if ($('#emailAgreeRadioY').is(':checked')) {
                    $('#emailAgreeChk').prop("checked", true);
                    $emailAgreePopup.find('.btn-close').trigger('click');
                } else {
                	lgkorUI.alert('', {
                        title: '개인정보 수집 이용에 동의해 주세요.'
                    }, $('#emailAgreeRadioY'));
                }
            });
            // 이메일인증 약관팝업 - 닫기
            $emailAgreePopup.find('.btn-close').on('click', function(e) {
                if ($('#emailAgreeRadioY').is(':checked')) {
                    $('#emailAgreeChk').prop("checked", true);
                    $('#emailAgreeChk').parents('.forms:eq(0)').find('.err-block').hide();
                } else {
                    $('#emailAgreeChk').prop("checked", false); 
                }
            });

            // 서류인증 클릭
            $('.doc-verification-info .btn-verification').on('click', function(e) {
                // 타입별 화면구성
                var docType = $(this).data('docType') || 'student'; // 학생, 교직원 구분
                $('#userType').val(docType);
                if (docType === 'staff') {
                    $('[name=studentOnly]').hide();
                    $('[name=staffOnly]').show();
                } else {
                    $('[name=studentOnly]').show();
                    $('[name=staffOnly]').hide();
                }
                // 서류인증 증빙서류 영역 접기
                if($('.accordion-border-wrap .lists').hasClass('on')) {
                    $('.ui_accord_toggle').trigger('click');
                }
                // 서류인증 초기화
                $('#schoolName, #majorName').val('');
                $('input[name=docAgreeChk]').prop('checked', false);
                $('input[name=docAgreeRadio]').prop('checked', false);
                $docAgreePopup.find('.btn-confirm').addClass('disabled');
                $docPopup.find('.ui_imageinput').vcImageFileInput('removeAll');
                $docPopup.find('.err-block').hide();
            });

            self.$emailInput.on('input', function(e) {
                var $this = $(this),
                    value = $this.val(),
                    regex = /[^a-zA-Z0-9._\-\@]/g; 
                if (regex.test(value)) {
                    $this.val(value.replace(regex, ""));
                    return;
                } else {
                    $this.val(value.toLowerCase());
                }
            });

        },

        memberCheck : function() {
            var planEventId = $('#planEventId').val();
            var url = $('#planEventId').data("memberCheckUrl");
                url = url || "/evt/api/exhibitions/retrieveAcademyAuth.lgajax?planEventId=" + planEventId;
            var memberStatus = '';
            if(url) {
                $.ajax({
                    type: "POST",
                    async: false,
                    url: url,
                    dataType: "json",
                    success: function(json) {
                        memberStatus = json.data;
                    },
                    error: function(request, status, error) {
                        if(location.hostname !== "localhost") {
                            lgkorUI.alert('', {
                                title: '오류가 발생하였습니다.'
                            });
                        }
                        return;
                    }
                });
            }
            return memberStatus;
        },
        paramChk : function() {
            paramValue = $('#paramValue').val();    // BTOCSITE-33283

            if(typeof paramValue == "undefined" || paramValue == null || paramValue == "") {
                paramValue = "";
            }
            return paramValue;
        }, 
        // BTOCSITE-33505 LG전자 아카데미 스토어 대문 변경 요청 > 유의사항 토글
        toggleOpenClick: function(){
            var toggleBtn = $('.notice-toggle-tit .btn-notice-toggle')
            var toggleArea = toggleBtn.parents('.event-notice-area');
            var toggleCont = toggleBtn.parent().siblings('.notice-toggle-cont');
            toggleBtn.click(function (e) {
                if ($(e.target).is('.active')) {
                    toggleBtn.removeClass('active');
                    toggleArea.removeClass('active');
                    toggleCont.slideUp(300);
                } else {
                    toggleBtn.addClass('active');
                    toggleArea.addClass('active');
                    toggleCont.slideDown(300);
                }

                // BTOCSITE-77414 [웹앱 접근성 개선활동] 전시_이벤트/멤버십
                var blind = $(e.target).find('.blind');
                blind.html('유의사항 확인하기 내용 ' + ($(e.target).is('.active') ? '닫기' : '열기'));
                $(e.target).attr('aria-expanded', $(e.target).is('.active'));

                return false;
            });

            // BTOCSITE-77414 [웹앱 접근성 개선활동] 전시_이벤트/멤버십
            toggleBtn.find('.blind').html('유의사항 확인하기 내용 ' + (toggleBtn.is('.active') ? '닫기' : '열기'));
            toggleBtn.attr('aria-expanded', toggleBtn.is('.active'));
        }
    };

    var docCertified = {
        init: function() {
            var self = this;
            self.$submitForm = $('#documentCertifiedForm');
            self.$completeBtn = $('#btnDocCertified');
            self.$schoolName = $('#schoolName');
            self.$majorName = $('#majorName');
            self.$schoolName.attr('maxlength', 50);
            self.$majorName.attr('maxlength', 50);

            vcui.require(['ui/imageFileInput', 'ui/validation'], function() {
                $docPopup.find('.ui_imageinput').vcImageFileInput({
                    totalSize: 10 * 1024 * 1024,
                    format: 'jpg|jpeg|png|JPG|JPEG|PNG',
                    message: {
                        format: '10MB 이하의 JPEG, PNG 파일만첨부 가능합니다.',
                        size: '첨부파일 크기는 10M 이하로 등록해 주세요.'
                    }
                });
            	
                var register = {
                    // 학교명
                    schoolName: {
                        required: true,
                        msgTarget: '.err-block',
                        errorMsg: '학교명을 입력해주세요.'
                    },
                    // 소속학과
                    majorName: {
                        required: true,
                        msgTarget: '.err-block',
                        errorMsg: '소속학과를 입력해주세요.'
                    },
                    // 약관동의
                    docAgreeChk: {
                        required: true,
                        msgTarget: '#documentCertifiedForm .input-mix-wrap + .err-block',
                        errorMsg: '개인정보 수집 이용에 동의해 주세요.'
                    },
                    // 증빙서류
                    evidenceDocuFile: {
                        required: true,
                        msgTarget: '.img-err-block',
                        errorMsg: '증빙서류를 등록해 주세요.'
                    }
                }
                docValidation = new vcui.ui.CsValidation('#documentCertifiedForm', {
                    register: register
                });
                self.bindEvent();
            });

        },
        bindEvent: function() {
            var self = this;
            // 서류 인증 신청 버튼 클릭시
            self.$completeBtn.on('click', function(e) {
                e.preventDefault();

                var planEventId = $('#planEventId').val();
                var memberStatus = emailCertified.memberCheck();

                if (memberStatus == 'Y') {
                    lgkorUI.alert("", {
                        title: '이미 인증 받은 회원입니다.<br>확인 버튼을 통해<br>아카데미 스토어를 이용해 주시기 바랍니다.',
                        okBtnName: '확인',
                        ok: function() {
                            location.href = "/benefits/exhibitions/detail-" + planEventId + paramValue;
                        }
                    });
                } else {
                    var result = docValidation.validate();
                    if (result.success) {
                        var url = self.$submitForm.data('ajax');
                        var param = docValidation.getAllValues();

                        var chk = $('#docAgreeChk').prop('checked');
                        if(chk){
                            param['agreeUserCheck'] = 1;
                        } else {
                            lgkorUI.alert("", {
                                title: '개인정보 수집 이용에 동의해 주세요.'
                            }, $('#docAgreeChk'));
                            return;
                        }
                        
                        lgkorUI.confirm('', {
                            title:'저장하시겠습니까?',
                            cancelBtnName: '아니오',
                            okBtnName: '예',
                            ok: function() {
                                var formData = new FormData();
                                for (var key in param) {
                                    formData.append(key, param[key]);
                                }
                                lgkorUI.showLoading();
                                lgkorUI.requestAjaxFileData(url, formData, function(result) {
                                    // 완료
                                    lgkorUI.hideLoading();
                                    if (result.status == 'success') {
                                        $emailPopup.vcModal('hide');
                                        $docPopup.vcModal('hide');
                                        $docSuccessPopup.vcModal('open');
                                    } else {
                                        if (result.message) {
                                            var isProgress = result.message.indexOf("확인중") > -1;
                                            lgkorUI.alert("", {title: result.message, ok: function() { 
                                                if (isProgress) {
                                                    $docPopup.vcModal('hide');
                                                    $emailPopup.vcModal('hide');
                                                }
                                            }}, self.$completeBtn);
                                        }
                                    }
                                }, 'POST', 'json', true
                                , function() {
                                    lgkorUI.hideLoading();
                                    lgkorUI.alert('', {
                                        title: '인증 신청중 오류가 발생했습니다.'
                                    }, self.$completeBtn);
                              });
                            }
                        });
                    } else {
                        if(result.validArray.length > 0) {
                            var $focus = $('[name='+result.validArray[0].key+']');
                            if ($focus.length === 0) $focus = self.$completeBtn;
                            lgkorUI.alert('', {title: result.validArray[0].errmsg, ok: function(){
                                academyUtil.scroll($focus);
                            }}, $focus);
                        }
                    }
                }
            });

            // 서류인증 - 신청완료 확인
            $docSuccessPopup.find('.ui_modal_close').on('click', function(e) {
                $docSuccessPopup.vcModal('hide');
            });

            // 서류인증 약관팝업 - 동의/비동의
            $("input:radio[name=docAgreeRadio]").on('click', function(e) {
                var $confirmBtn = $docAgreePopup.find('.btn-confirm');
                if ($(this).val() == "N") {
                    $confirmBtn.addClass('disabled');
                } else {
                    $confirmBtn.removeClass('disabled');
                }
            });

            // 서류인증 약관팝업 - 확인
            $docAgreePopup.find('.btn-confirm').on('click', function(e) {
                if ($('#docAgreeRadioY').is(':checked')) {
                    $('#docAgreeChk').prop("checked", true);
                    $docAgreePopup.find('.btn-close').trigger('click');
                } else {
                    lgkorUI.alert('', {
                        title: '개인정보 수집 이용에 동의해 주세요.'
                    }, $('#docAgreeRadioY'));
                }
            });

            // 서류인증 약관팝업 - 닫기
            $docAgreePopup.find('.btn-close').on('click', function(e) {
                if ($('#docAgreeRadioY').is(':checked')) {
                    $('#docAgreeChk').prop("checked", true);
                    $('#docAgreeChk').parents('.forms:eq(0)').find('.err-block').hide();
                } else {
                    $('#docAgreeChk').prop("checked", false); 
                }
            });

        }
    };

    var academyUtil = {
        scroll: function($input) {
            if ($input.length === 0) return;
            setTimeout(function() {
                $input[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }, 300);
        }
    };

    $(document).ready(function() {
        emailCertified.init();
        docCertified.init();
    });

})();